var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReaction2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 48,
    viewBox: "0 0 209 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(-885 -12483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    transform: "translate(885 12483)",
    fill: "none",
    stroke: "#7e7e7e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 208,
    height: 47,
    rx: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(-3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399",
    transform: "translate(37.973 6.506)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "VERY_GOOD",
    "data-name": "VERY GOOD",
    transform: "translate(928.027 12495.494)",
    fontSize: 15,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VERY GOOD")), /*#__PURE__*/React.createElement("text", {
    id: "_2_Likes_",
    "data-name": "(2 Likes)",
    transform: "translate(928.027 12512.494)",
    fontSize: 11,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(2 Likes)"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    d: "M20.638,3.615a6.1,6.1,0,0,0-8.33.607l-.879.906-.879-.906a6.1,6.1,0,0,0-8.33-.607A6.41,6.41,0,0,0,1.776,12.9l8.638,8.92a1.4,1.4,0,0,0,2.022,0l8.638-8.92a6.406,6.406,0,0,0-.437-9.281Z",
    transform: "translate(925.001 12492.752)",
    fill: "none",
    stroke: "red",
    strokeWidth: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction2);
export default __webpack_public_path__ + "static/media/reaction-2.f02a4c4b0bf2304143ee363915347ef1.svg";
export { ForwardRef as ReactComponent };